import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for "Join these days": un-flags a pair in
 * state.disconnectedStageIds after the user joins a day back onto the next.
 * The leg that joins them is tracked by the RouteSnapshotsCommand that
 * reconnectStages pushes separately — this command only restores the
 * disconnected flag on undo, and only exists at all when the pair had
 * actually been separated (see reconnectStages in drag-preview.ts).
 */
export class ReconnectStagesCommand implements UndoCommand {
  readonly type: string = 'RECONNECT_STAGES';
  readonly routeKey: string | null = null;

  constructor(private connectorId: string) {}

  undo(ctx: CommandContext): void {
    if (!ctx.state.disconnectedStageIds.includes(this.connectorId)) {
      ctx.state.disconnectedStageIds.push(this.connectorId);
    }
  }

  redo(ctx: CommandContext): void {
    ctx.state.disconnectedStageIds =
      ctx.state.disconnectedStageIds.filter(id => id !== this.connectorId);
  }
}
